import { jsx as _jsx } from "react/jsx-runtime";
import LinkEditor from "@administration/components/editor/LinkEditor";
import { Link, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import MuiButton from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Icon from "@shared/components/Icon";
import React, { useMemo, useState } from "react";
export const componentClassName = "MuiButton-root";
const GradientButton = (props) => {
    const [hover, setHover] = useState(false);
    const { id, isBo, justifyContent = "flex-start", onClick, onMouseOut, onMouseOver, variant, color, children, sx, text, mobileText, ...others } = props;
    const icon = useMemo(() => {
        if (typeof props.icon === "string") {
            return { icon: props.icon };
        }
        return props.icon;
    }, [props.icon]);
    const theme = useTheme();
    const isMobile = !useMediaQuery(theme.breakpoints.up("md"));
    const textContent = mobileText !== "" && isMobile ? mobileText : text;
    const WrapperComponent = variant === "icon" ? IconButton : MuiButton;
    const iconElement = icon && icon.icon && (_jsx(Icon, { ...icon, color: icon?.color, hover: hover, title: typeof children === "string" ? children : undefined, style: { fontSize: 20, maxWidth: 20, maxHeight: 20 } }));
    let btn;
    btn = (_jsx(WrapperComponent, { id: id, component: isBo ? LinkEditor : Link, color: color, ...(variant === "icon"
            ? {
                sx: {
                    ...sx,
                    backgroundColor: "transparent",
                    "&:hover": {
                        ...sx?.["&:hover"],
                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                    },
                },
            }
            : {
                variant,
                endIcon: iconElement,
                color,
                sx: {
                    ...sx,
                    boxShadow: "0px 5px 34px 0px #FFFFFF6B, 0px 20px 50px 0px #0000FF1A",
                },
            }), ...others, onMouseOver: (e) => {
            setHover(true);
            if (typeof onMouseOver === "function") {
                onMouseOver(e);
            }
        }, onMouseOut: (e) => {
            setHover(false);
            if (typeof onMouseOut === "function") {
                onMouseOut(e);
            }
        }, onClick: () => {
            setHover(true);
            if (typeof onClick === "function") {
                onClick();
            }
        }, children: variant === "icon" ? iconElement : textContent }));
    if (justifyContent && justifyContent !== "flex-start") {
        return (_jsx(Box, { display: "flex", justifyContent: justifyContent, children: btn }));
    }
    return btn;
};
export default GradientButton;
